(() => {
  const SECTION_SELECTOR = '.jax-product-page';
  const ITEM_SELECTOR = '[data-jax-product-accordion-item]';
  const BUTTON_SELECTOR = '[data-jax-product-accordion-button]';

  function closeItem(item) {
    const button = item.querySelector(BUTTON_SELECTOR);

    item.classList.remove('is-open');

    if (button) {
      button.setAttribute('aria-expanded', 'false');
    }
  }

  function openItem(item) {
    const button = item.querySelector(BUTTON_SELECTOR);

    item.classList.add('is-open');

    if (button) {
      button.setAttribute('aria-expanded', 'true');
    }
  }

  function initialiseProductPage(section) {
    if (!section || section.dataset.jaxProductPageInitialised === 'true') {
      return;
    }

    section.dataset.jaxProductPageInitialised = 'true';

    const accordion = section.querySelector(
      '[data-jax-product-accordion]'
    );

    if (!accordion) return;

    accordion.addEventListener('click', (event) => {
      const button = event.target.closest(BUTTON_SELECTOR);

      if (!button || !accordion.contains(button)) return;

      const currentItem = button.closest(ITEM_SELECTOR);

      if (!currentItem) return;

      const isCurrentlyOpen =
        currentItem.classList.contains('is-open');

      /* Keep only one accordion panel open at a time */
      accordion.querySelectorAll(ITEM_SELECTOR).forEach((item) => {
        if (item !== currentItem) {
          closeItem(item);
        }
      });

      if (isCurrentlyOpen) {
        closeItem(currentItem);
      } else {
        openItem(currentItem);
      }
    });
  }

  function initialiseAllProductPages(root = document) {
    if (root.matches?.(SECTION_SELECTOR)) {
      initialiseProductPage(root);
    }

    root.querySelectorAll?.(SECTION_SELECTOR).forEach(
      initialiseProductPage
    );
  }

  function init() {
    initialiseAllProductPages();

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAllProductPages(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });
  } else {
    init();
  }
})();